import React from 'react';
import {fileBaseUrl} from "../../utils";
import {Image} from 'antd';


const CertificationRules = () => {
    const comFile: string = fileBaseUrl();
    const pngUrl = `${comFile}certificationRulesPublicInformation.png`;

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <h3>认证规则公开信息</h3>
            <Image
                src={pngUrl}
                alt="认证规则公开信息"
                style={{maxWidth: '100%', cursor: 'pointer'}}
                preview={{
                    mask: false,               // 不需要额外蒙层文字
                    destroyOnClose: true,      // 关闭后销毁预览节点
                }}
            />
        </div>
    );
};

export default CertificationRules;